import { allowOnlyGuests } from '@/router/routerGuards'

import router from '@/router'

// Setup routes
export default () => {
  router.addRoute({
    path: '/login',
    component: () => import('../../components/OnboardingWrapper.vue'),
    alias: ['/sign-up/login'],
    children: [
      {
        path: '',
        name: 'login',
        components: {
          default: () => import('./signIn.vue'),
          geometricBackground: () => import('../../components/GeometricBackground.vue')
        },
        beforeEnter: allowOnlyGuests()
      }
    ]
  })

  router.addRoute({
    path: '/mfa-callback',
    name: 'mfa-callback',
    component: () => import('./mfaCallback.vue'),
    meta: { disablePageViewTracking: true }
  })
}
